import {
  getPromotionTableVariables,
  promotionTableDefaultSorting,
} from "@/app/Promotions/Components/PromotionTable";
import { PROMOTION_STAT_DAYS } from "@/app/Promotions/Components/PromotionStatBlocks";
import { promotionCountsQuery } from "@/app/Promotions/GraphQL/promotionCountsQuery";
import { promotionStatsQuery } from "@/app/Promotions/GraphQL/promotionStatsQuery";
import { relocationPromotionListQuery } from "@/app/Promotions/GraphQL/relocationPromotionListQuery";
import { AdTableScreen } from "@/app/Promotions/Screens/AdTableScreen";
import { adTabActive } from "@/app/Promotions/Utils/adTabs";
import { supplierParamToId } from "@/app/Suppliers/Utils/globalSupplier";
import { createQueryVariables } from "@/lib/Components/DataTable/utils/data-table-utils";
import { fetchQuery } from "@/lib/GraphQLCodegen/fetcher";
import { appLayoutRoute } from "@/routes/layout-routes";
import { createRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const adSearchParams = z.object({
  adTab: fallback(z.enum(["active", "inactive", "all"]), "active").default(
    "active",
  ),
});

export type AdSearchParams = z.infer<typeof adSearchParams>;

export const adTableRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/ads",
  component: AdTableScreen,
  validateSearch: zodValidator(adSearchParams),
  loaderDeps: ({ search }) => search,
  loader: ({ deps, params }) => {
    const supplierId = supplierParamToId(params.supplierId);

    return Promise.all([
      fetchQuery(
        relocationPromotionListQuery,
        createQueryVariables(
          "ads",
          getPromotionTableVariables({
            supplierId: supplierId ?? undefined,
            active: adTabActive(deps.adTab),
          }),
          promotionTableDefaultSorting,
        ),
        params.orgId,
      ),
      fetchQuery(
        promotionStatsQuery,
        { days: PROMOTION_STAT_DAYS },
        params.orgId,
      ),
      fetchQuery(promotionCountsQuery, {}, params.orgId),
    ]);
  },
  head: () => ({
    meta: [
      {
        title: "Ads - Imoova Admin",
      },
      {
        name: "description",
        content: "Preview and track running ads",
      },
    ],
  }),
});
